import dynamic from "next/dynamic";
import React, { useEffect, useState } from "react";
const DynamicMap = dynamic(
  () => import("components/maps/DynamicMap/DynamicMap")
);
const MapMarker = dynamic(() => import("components/maps/MapMarker/MapMarker"));
// const useInView = dynamic(() =>
//   import("react-cool-inview").then((mod) => mod.useInView)
// );
import { useInView } from "react-cool-inview";

import { stripHtmlTags } from "../../utils";
import { generateGeoJSONObject } from "../../utils/helpers/geoJSON";

import styles from "./KeyFacts.module.scss";

const KeyFacts = ({ destination, lat, lng, experiences }) => {
  const [experienceGeoJSON, setExperienceGeoJSON] = useState({
    type: "FeatureCollection",
    features: [],
  });

  const { observe, inView } = useInView({
    onEnter: ({ unobserve }) => unobserve(),
  });

  const subItems = destination.key_facts?.sub_item
    ? destination?.key_facts?.sub_item
        .filter((subItem) => subItem?.sub_heading !== "Long/Lat")
        .map((subItem) => {
          if (subItem.sub_heading === "Government") {
            return;
          }
          const sub_item_description = stripHtmlTags(
            subItem?.sub_item_description
          );
          return {
            ...subItem,
            sub_item_description,
          };
        })
        .filter((item) => item !== undefined)
    : [];

  lat = Number(lat);
  lng = Number(lng);

  useEffect(() => {
    if (!inView) {
      return;
    }
    setExperienceGeoJSON({
      type: "FeatureCollection",
      features: [],
    });

    experiences
      ? experiences?.forEach((experience, index) => {
          experience.location.forEach((location) => {
            const cities = location?.cities;

            // if (!cities || cities.length === 0) {
            //   return;
            // }

            cities.forEach((city) => {
              const { id, name, lat, lng } = city;

              const geoJSONObject = generateGeoJSONObject(
                experience?.id,
                lng,
                lat,
                name,
                {
                  title: experience.experience_title,
                  image: experience?.seo?.metaMedia?.url,
                  description: `${experience?.seo?.metaDescription
                    .split(" ")
                    .slice(0, 12)
                    .join(" ")}...`,

                  link: `/experience/${experience.slug}`,

                  offset: [0, -15],
                  imageTags: experience?.experience_categories?.map(
                    (category) => category.category_name
                  ),
                  data: experience,
                  type: "experience",
                }
              );

              setExperienceGeoJSON((previous) => {
                const next = { ...previous };

                next.features.push(geoJSONObject);
                next.features = Array.from(new Set(next?.features));

                return next;
              });
            });
          });
        })
      : [];
  }, [experiences, inView]);

  if (!destination?.key_facts?.sub_item?.length) {
    return <></>;
  }
  let findCapitalCity;

  if (
    !!destination?.cities.length &&
    destination?.key_facts &&
    destination?.key_facts?.sub_item.find(
      (item) => item.sub_heading === "Capital"
    )
  ) {
    findCapitalCity = destination?.cities?.find((city) => {
      return (
        city.name
          .toLowerCase()
          .includes(
            destination?.key_facts?.sub_item[0]?.sub_item_description.toLowerCase()
          ) ||
        destination?.key_facts?.sub_item[0]?.sub_item_description
          .toLowerCase()
          .toLowerCase()
          .includes(city.name.toLowerCase()) ||
        destination?.key_facts?.sub_item[0]?.sub_item_description
          .toLowerCase()
          .toLowerCase()
          .includes(city.slug.replace("-", " "))
      );
    });
  }

  const capitalCity = findCapitalCity ?? destination?.cities[0];

  let capitalMapMarker;

  if (
    !!capitalCity &&
    capitalCity !== null &&
    !!capitalCity?.lat &&
    !!capitalCity?.lng
  ) {
    capitalMapMarker = (
      <MapMarker
        latitude={parseFloat(capitalCity?.lat) + 0.005}
        longitude={parseFloat(capitalCity?.lng)}
        iconName="GoogleMapsMarker"
        iconColor="#EA4335"
      />
    );
  }

  return (
    <div className={`variable-container ${styles.container}`}>
      <div className={`${styles.countryDetailWrapper}`}>
        <div className={`${styles.keyText}`}>
          {subItems &&
            subItems?.map((item, index) => (
              <span
                key={`${index}-${item?.sub_heading.split(" ")[0]}`}
                className={`${styles.textContainer}`}
              >
                <h3 className={`${styles.subHeading}`}>{item?.sub_heading}:</h3>

                <span className={`${styles.subDescription}`}>
                  {item?.sub_item_description}
                </span>
              </span>
            ))}
        </div>

        <div className={`${styles.mapContainer}`} ref={observe}>
          {inView && (
            <DynamicMap
              lat={capitalCity?.lat ?? lat}
              lng={capitalCity?.lng ?? lng}
              zoom={5}
              geoJSON={experienceGeoJSON}
              markers={capitalMapMarker ? capitalMapMarker : []}
              mapSourceID="destination-map"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default KeyFacts;
